import React from 'react';
import AddUpdateProductPackage from './pages/ProductPackage/AddUpdateProductPackage';
const BrandList = React.lazy(() => import('./pages/Products/Brands/BrandList'));
const CategoryList = React.lazy(() => import('./pages/Products/Categories/CategoryList'));
const UnitList = React.lazy(() => import('./pages/Products/Units/UnitList'));
const WarehouseList = React.lazy(() => import('./pages/Products/Warehouses/WarehouseList'));
const CompanySetting = React.lazy(() => import('./pages/Company/CompanySetting'));
const SupplierList = React.lazy(() => import('./pages/Suppliers/SupplierList'));
const VariationMasterList = React.lazy(() => import('./pages/Products/VariationMaster/VariationMasterList'));
const ProductMasterList = React.lazy(() => import('./pages/Products/ProductMaster/ProductMasterList'));
const AddUpdateProductMaster = React.lazy(() => import('./pages/Products/ProductMaster/AddUpdateProductMaster'));
const WarehouseStockList = React.lazy(() => import('./pages/WarehouseStocks/WarehouseStockList'));
const PurchaseOrderList = React.lazy(() => import('./pages/PurchaseOrder/PurchaseOrderList'));
const AddUpdatePurchaseOrder = React.lazy(() => import('./pages/PurchaseOrder/AddUpdatePurchaseOrder'));
const PurchaseOrderInvoiceList = React.lazy(() => import('./pages/PurchaseOrderInvoice/PurchaseOrderInvoiceList'));
const AddUpdatePurchaseOrderInvoice = React.lazy(
  () => import('./pages/PurchaseOrderInvoice/AddUpdatePurchaseOrderInvoice'),
);
const ProductPackageList = React.lazy(() => import('./pages/ProductPackage/ProductPackageList'));
const RolesPermissionList = React.lazy(() => import('./pages/Roles&Permission/RolesPermissionList'));
const UserList = React.lazy(() => import('./pages/Users/UserList'));
const ExpenseCategoryList = React.lazy(() => import('./pages/ExpenseCategory/ExpenseCategoryList'));
const ExpensesList = React.lazy(() => import('./pages/Expenses/ExpensesList'));
const CustomerList = React.lazy(() => import('./pages/Customers/CustomerList'));
const CustomerSchedulePackageList = React.lazy(
  () => import('./pages/CustomerSchedulePackage/CustomerSchedulePackageList'),
);
const BatchList = React.lazy(() => import('./pages/POS/Batch/BatchList'));
const ShiftList = React.lazy(() => import('./pages/POS/Shift/ShiftList'));
const TerminalMasterList = React.lazy(() => import('./pages/POS/TerminalMaster/TerminalMasterList'));
const CheckInOutList = React.lazy(() => import('./pages/POS/checkInOut/CheckInOutList'));

// import BrandList from './pages/Products/Brands/BrandList';
// import CategoryList from './pages/Products/Categories/CategoryList';

// import UnitList from './pages/Products/Units/UnitList';
// import WarehouseList from './pages/Products/Warehouses/WarehouseList';
// import CompanySetting from './pages/Company/CompanySetting';
// import SupplierList from './pages/Suppliers/SupplierList';
// import VariationMasterList from './pages/Products/VariationMaster/VariationMasterList';
// import ProductMasterList from './pages/Products/ProductMaster/ProductMasterList';
// import AddUpdateProductMaster from './pages/Products/ProductMaster/AddUpdateProductMaster';
// import WarehouseStockList from './pages/WarehouseStocks/WarehouseStockList';
// import PurchaseOrderList from './pages/PurchaseOrder/PurchaseOrderList';
// import AddUpdatePurchaseOrder from './pages/PurchaseOrder/AddUpdatePurchaseOrder';
// import PurchaseOrderInvoiceList from './pages/PurchaseOrderInvoice/PurchaseOrderInvoiceList';
// import AddUpdatePurchaseOrderInvoice from './pages/PurchaseOrderInvoice/AddUpdatePurchaseOrderInvoice';

export const route = [
  {
    requiredModule: 'Brands',
    requiredActions: ['list'],
    path: '/brands',
    element: <BrandList />,
  },
  {
    requiredModule: 'Categories',
    requiredActions: ['list'],
    path: '/categories',
    element: <CategoryList />,
  },
  {
    requiredModule: 'Units',
    requiredActions: ['list'],
    path: '/units',
    element: <UnitList />,
  },
  {
    requiredModule: 'Variations',
    requiredActions: ['list'],
    path: '/variations',
    element: <VariationMasterList />,
  },
  {
    requiredModule: 'Products',
    requiredActions: ['list'],
    path: '/products',
    element: <ProductMasterList />,
  },
  {
    requiredModule: 'Products',
    requiredActions: ['create'],
    path: '/products/create',
    element: <AddUpdateProductMaster />,
  },
  {
    requiredModule: 'Products',
    requiredActions: ['edit'],
    path: '/products/edit/:id',
    element: <AddUpdateProductMaster />,
  },
  {
    requiredModule: 'Warehouse',
    requiredActions: ['list'],
    path: '/warehouse',
    element: <WarehouseList />,
  },
  {
    requiredModule: 'Company',
    requiredActions: ['list'],
    path: '/company',
    element: <CompanySetting />,
  },
  {
    requiredModule: 'Supplier',
    requiredActions: ['list'],
    path: '/supplier',
    element: <SupplierList />,
  },
  {
    requiredModule: 'Warehouse Stock',
    requiredActions: ['list'],
    path: '/warehouse-stock',
    element: <WarehouseStockList />,
  },
  {
    requiredModule: 'Purchase',
    requiredActions: ['list'],
    path: '/purchase',
    element: <PurchaseOrderList />,
  },
  {
    requiredModule: 'Purchase',
    requiredActions: ['create'],
    path: '/purchase/create',
    element: <AddUpdatePurchaseOrder />,
  },
  {
    requiredModule: 'Purchase',
    requiredActions: ['edit'],
    path: '/purchase/edit/:id',
    element: <AddUpdatePurchaseOrder />,
  },
  {
    requiredModule: 'Purchase Invoice',
    requiredActions: ['list'],
    path: '/purchase-invoice',
    element: <PurchaseOrderInvoiceList />,
  },
  {
    requiredModule: 'Purchase Invoice',
    requiredActions: ['create'],
    path: '/purchase-invoice/create',
    element: <AddUpdatePurchaseOrderInvoice />,
  },
  {
    requiredModule: 'Purchase Invoice',
    requiredActions: ['edit'],
    path: '/purchase-invoice/edit/:id',
    element: <AddUpdatePurchaseOrderInvoice />,
  },
  {
    requiredModule: 'Product Package',
    requiredActions: ['list'],
    path: 'schedule/product-package',
    element: <ProductPackageList />,
  },
  {
    requiredModule: 'Product Package',
    requiredActions: ['create'],
    path: '/schedule/product-package/create',
    element: <AddUpdateProductPackage />,
  },
  {
    requiredModule: 'Product Package',
    requiredActions: ['edit'],
    path: '/schedule/product-package/edit/:id',
    element: <AddUpdateProductPackage />,
  },
  {
    requiredModule: 'Roles & Permission',
    requiredActions: ['list'],
    path: '/roles',
    element: <RolesPermissionList />,
  },
  {
    requiredModule: 'Users',
    requiredActions: ['list'],
    path: '/users',
    element: <UserList />,
  },
  {
    requiredModule: 'Customers',
    requiredActions: ['list'],
    path: '/customers',
    element: <CustomerList />,
  },
  {
    requiredModule: 'Customer Schedule Package',
    requiredActions: ['list'],
    path: '/customer-schedule-package',
    element: <CustomerSchedulePackageList />,
  },
  {
    requiredModule: 'Expenses',
    requiredActions: ['list'],
    path: '/expenses',
    element: <ExpensesList />,
  },
  {
    requiredModule: 'Expense Categories',
    requiredActions: ['list'],
    path: '/expenses/categories',
    element: <ExpenseCategoryList />,
  },
  {
    requiredModule: 'Batch',
    requiredActions: ['list'],
    path: '/batch',
    element: <BatchList />,
  },
  {
    requiredModule: 'Shift',
    requiredActions: ['list'],
    path: '/shift',
    element: <ShiftList />,
  },
  {
    requiredModule: 'Terminal Master',
    requiredActions: ['list'],
    path: '/terminal-master',
    element: <TerminalMasterList />,
  },
  {
    requiredModule: 'CheckInOut',
    requiredActions: ['list'],
    path: '/check-in-out',
    element: <CheckInOutList />,
  },
];
